export default {
  EBI_818: '818'
}
